import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { navMenuArray } from "../../data/arrays/navMenuArray";
import "../../index.css";
import "./navigation.css";

const Navigation = ({ isToggle, setIsToggle, navActive }) => {
  const [activeNavItem, setActiveNavItem] = useState(null);

  const location = useLocation();
  const sessionScope = useSelector((state) => state.sessionData.sessionScope);

  const [submenuOpen, setSubmenuOpen] = useState(
    Array(navMenuArray.NavMenuPermission.length).fill(false)
  );
  const toggleSubmenu = (index) => {
    const newSubmenuOpen = [...submenuOpen];
    newSubmenuOpen[index] = !newSubmenuOpen[index]; // Toggle the clicked submenu
    setSubmenuOpen(
      newSubmenuOpen.map((value, i) => (index === i ? value : false))
    ); // Close other submenus if the clicked submenu is opened
  };

  const isMenuActive = (menuURL) => {
    return location.pathname === "/" + menuURL;
  };

  const isParentActive = (parentIndex) => {
    return (
      activeNavItem === parentIndex ||
      sessionScope.NavSubMenuPermission.filter(
        (submenu) =>
          submenu.navMenuId ===
          sessionScope.NavMenuPermission[parentIndex].navMenuId
      ).some((subMenuObj) => isMenuActive(subMenuObj.menuURL))
    );
  };

  const handleNavItemClick = (index) => {
    setActiveNavItem(index);
  };

  return (
    <div
      id="m_aside_left"
      // onMouseEnter={()=>setIsToggle(true)}
      // onMouseLeave={()=>setIsToggle(false)}
      className={`m-grid__item	m-aside-left  m-aside-left--skin-dark ${
        isToggle ? "m-aside-left--on" : ""
      }`}
      style={{ overflow: "auto" }}
      onMouseEnter={() => !navActive && setIsToggle(false)}
      onMouseLeave={() => !navActive && setIsToggle(true)}
      // style={{width: isToggle ? '220px' : '78px', left:isToggle ? '0 !important' : '-230px !important'}}
    >
      <div
        id="m_ver_menu"
        className="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark"
        m-menu-vertical="1"
        m-menu-scrollable="1"
        m-menu-dropdown-timeout="500"
      >
        <ul className="m-menu__nav ">
          {sessionScope &&
            sessionScope?.NavMenuPermission?.map((menuObj, index) =>
              menuObj.menuURL != "#" ? (
                <React.Fragment key={index}>
                  <li
                    className={`m-menu__item ${
                      isMenuActive(menuObj.menuURL) ? "active" : ""
                    }`}
                    onClick={() => handleNavItemClick(index)}
                    aria-haspopup="true"
                  >
                    <a
                      href={"/" + menuObj.menuURL}
                      target={menuObj.menuURL == "pos/new" ? "_blank" : ""}
                      className="m-menu__link aaaa add_for_target"
                    >
                      <span className="m-menu__item-here"></span>
                      <i
                        style={
                          isToggle
                            ? { textAlign: "center", color: "#fff" }
                            : { textAlign: "left", color: "#bbbbbb" }
                        }
                        className={"m-menu__link-icon " + menuObj.iconClass}
                      ></i>
                      <span
                        className="m-menu__link-text"
                        style={{ display: isToggle ? "none" : "table-cell" }}
                      >
                        {menuObj.title}
                      </span>
                    </a>
                  </li>
                </React.Fragment>
              ) : (
                <React.Fragment key={index}>
                  <li
                    key={index}
                    className={`m-menu__item m-menu__item--submenu ${
                      submenuOpen[index] ? "m-menu__item--open" : ""
                    } ${isParentActive(index) ? "active" : ""}`}
                    aria-haspopup="true"
                    onClick={() => toggleSubmenu(index)}
                  >
                    <a href="javascript:;" className="m-menu__link m-menu__toggle">
                      <span className="m-menu__item-here"></span>
                      <i
                        style={
                          isToggle
                            ? { textAlign: "center", color: "#fff" }
                            : { textAlign: "left", color: "##bbbbbb" }
                        }
                        className={"m-menu__link-icon " + menuObj.iconClass}
                      ></i>
                      <span
                        className="m-menu__link-text"
                        style={{ display: isToggle ? "none" : "table-cell" }}
                      >
                        {menuObj.title}
                      </span>
                      <i
                        className="m-menu__ver-arrow fa fa-angle-right"
                        style={{ display: isToggle ? "none" : "table-cell" }}
                      ></i>
                    </a>
                    <div
                      className={"m-menu__submenu"}
                      style={{
                        maxHeight: submenuOpen[index] ? "100%" : "0",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease 0.3s",
                      }}
                    >
                      <span className="m-menu__arrow"></span>
                      <ul
                        className="m-menu__subnav"
                        style={{ display: isToggle ? "none" : "table-cell" }}
                      >
                        {sessionScope &&
                          sessionScope?.NavSubMenuPermission?.filter(
                            (sub) => sub.isSubMenu == 1
                          )
                            ?.filter(
                              (submenu) =>
                                submenu.navMenuId === menuObj.navMenuId
                            )
                            .map((subMenuObj, index) => {
                              return (
                                <li
                                  key={index} // Don't forget to add a unique key for each list item
                                  className={`m-menu__item ${
                                    activeNavItem === index ||
                                    isMenuActive(subMenuObj.menuURL)
                                      ? "active"
                                      : ""
                                  }`}
                                  aria-haspopup="true"
                                  m-menu-link-redirect="1"
                                >
                                  <a
                                    href={"/" + subMenuObj.menuURL}
                                    className="m-menu__link add_for_target"
                                  >
                                    <i className="m-menu__link-bullet m-menu__link-bullet--dot">
                                      <span></span>
                                    </i>
                                    <span className="m-menu__link-text">
                                      {subMenuObj.title}
                                    </span>
                                  </a>
                                </li>
                              );
                            })}
                      </ul>
                    </div>
                  </li>
                </React.Fragment>
              )
            )}
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
